var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.046 .92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.156-.65A3.806 3.806 0 1 1-.65 3.156 3.81 3.81 0 0 1 3.156-.65zm0 6.312A2.506 2.506 0 1 0 .65 3.156a2.509 2.509 0 0 0 2.506 2.506z",
    transform: "translate(4.29 3.503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.081 13.073a.65.65 0 0 1-.571-.959 5.611 5.611 0 0 1 9.84-.071.65.65 0 1 1-1.135.634 4.311 4.311 0 0 0-7.562.055.65.65 0 0 1-.572.341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.257 16.907a.648.648 0 0 1-.46-.19l-3.568-3.568a8.047 8.047 0 0 1-4.147 1.74 7.045 7.045 0 0 1-5.9-2.177A7.447 7.447 0 1 1 12.712 2.18a7.458 7.458 0 0 1 .44 10.052l3.565 3.568a.65.65 0 0 1-.46 1.11zM7.446 1.3a6.143 6.143 0 1 0 4.346 1.8 6.129 6.129 0 0 0-4.346-1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.5ade5a58caadafcd07bd488782c09ed0.svg";
export { ForwardRef as ReactComponent };